export const isProduction = process.env.APP_ENV === 'prod';
export const isStaging = process.env.APP_ENV === 'sta';
export const posthogProjectApiKey = process.env.POSTHOG_PROJECT_API_KEY;
